import { Link } from "react-router-dom";
import { BASE_URL } from "../../../utility/BaseUrl";
import { formatNumber } from "../../../utility/Formater";
import { useState } from "react";
import { RemoveItemOrderService } from "../../../services/MainScreen";
import Swal from "sweetalert2";

const BasketBoxComponent = ({ setData, item }) => {
  const [deleteItemLoading, setDeleteItemLoading] = useState({
    deleteItemLoading: false,
  });
  const handleRemoveItemCart = () => {
    setDeleteItemLoading({
      deleteItemLoading: true,
    });
    try {
      Swal.fire({
        title: "آیا مطمئن هستید؟",
        text: "این آیتم از سبد خرید شما حذف خواهد شد.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بله، حذف شود!",
        cancelButtonText: "لغو",
      }).then(async (result) => {
        if (result.isConfirmed) {
          let responseCart = await RemoveItemOrderService(item.id);
          if (responseCart.status === 0)
            return Swal.fire({
              icon: "error",
              title: "خطا",
              text: "خطا در پاک کردن یک محصول از سبد.",
              timer: 2000,
              showConfirmButton: false,
              position: "top-end",
              toast: true,
            });

          const { items, id, is_finished, total } = responseCart.result;
          setData((prevState) => ({
            ...prevState,
            user: {
              ...prevState.user,
              cart: {
                id: id,
                items: items,
                is_finished: is_finished,
                total: total,
              },
            },
          }));
          Swal.fire({
            icon: "success",
            title: "موفقیت",
            text: responseCart.message,
            timer: 2000,
            showConfirmButton: false,
            position: "center-center",
            toast: true,
          });
        }
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "خطا",
        text: "خطا در کاهش محصول از سبد.",
        timer: 2000,
        showConfirmButton: false,
        position: "top-end",
        toast: true,
      });
    } finally {
      setDeleteItemLoading({
        deleteItemLoading: false,
      });
    }
  };
  const p = item.product;
  if (typeof p.inventory_of_product.final_price === "number")
    p.inventory_of_product.final_price = `${formatNumber(
      p.inventory_of_product.final_price
    )} تومان`;
  if (p)
    return (
      <>
        {/* <div>
                                      <form
                                        name="items"
                                        className="top-menu-basket-item"
                                      >
                                        <div className="top-menu-basket-item-image">
                                          <Link
                                            to={"/Product/" + p.slug}
                                            className="top-menu-basket-item-image-link"
                                          >
                                            <img
                                              className="img-responsive top-menu-basket-item-image-element"
                                              src={BASE_URL + p.product_cover}
                                              title={p.product_cover_title}
                                              alt={p.product_cover_alt}
                                              style={{ maxHeight: "60px" }}
                                            />
                                          </Link>
                                        </div>
                                        <div class="top-menu-basket-item-details">
                                          <h5 class="top-menu-basket-item-title">
                                            <Link
                                              class="top-menu-basket-item-link"
                                              to={"/Product/" + p.slug}
                                            >
                                              {p.product_name}
                                              <span class="top-menu-basket-item-subtitle">
                                                item.subtitle
                                              </span>
                                            </Link>
                                          </h5>
                                          <h6 class="top-menu-basket-item-price">
                                            {formatNumber(
                                              p.inventory_of_product.final_price
                                            )}{" "}
                                            تومان
                                          </h6>
                                          <a
                                            href="javascript:;"
                                            class="badge badge-danger top-menu-basket-item-remove"
                                          >
                                            <i class="fa fa-fw fa-times"></i>
                                            <i class="fa fa-fw fa-refresh fa-spin"></i>
                                            حذف
                                          </a>
                                        </div>
                                      </form>
                                    </div> */}
        <section className={"header-basket-item"}>
          <div className="header-basket-item-image">
            <Link
              to={"/Product/" + p.slug}
              className="header-basket-item-image-link"
            >
              <img
                className="img-responsive header-basket-item-image-element"
                src={BASE_URL + p.product_cover}
                title={p.product_cover_title}
                alt={p.product_cover_alt}
                style={{ maxHeight: "60px" }}
              />
            </Link>
          </div>
          <div className="header-basket-item-details">
            <h5 className="header-basket-item-title">
              <Link
                to={"/Product/" + p.slug}
                className="header-basket-item-link"
                // style={{ color: "#000" }}
              >
                {p.product_name}
                {/* <span className="header-basket-item-subtitle">
            item.subtitle
          </span> */}
              </Link>
            </h5>
            <h6 className="header-basket-item-price">
              {p.inventory_of_product.final_price}
            </h6>
            <button
              type="button"
              onClick={handleRemoveItemCart}
              className="badge badge-danger header-basket-item-remove border-0"
            >
              <i className="fa fa-fw fa-times" />
              {deleteItemLoading.deleteItemLoading ? (
                <i className="fa fa-fw fa-refresh fa-spin" />
              ) : null}
              حذف
            </button>
          </div>
        </section>
      </>
    );
};

export default BasketBoxComponent;

export const BasketBoxComponent2 = ({ setData, item }) => {
  const [deleteItemLoading, setDeleteItemLoading] = useState({
    deleteItemLoading: false,
  });
  const handleRemoveItemCart = () => {
    setDeleteItemLoading({
      deleteItemLoading: true,
    });
    try {
      Swal.fire({
        title: "آیا مطمئن هستید؟",
        text: "این آیتم از سبد خرید شما حذف خواهد شد.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بله، حذف شود!",
        cancelButtonText: "لغو",
      }).then(async (result) => {
        if (result.isConfirmed) {
          let responseCart = await RemoveItemOrderService(item.id);
          if (responseCart.status === 0)
            return Swal.fire({
              icon: "error",
              title: "خطا",
              text: "خطا در پاک کردن یک محصول از سبد.",
              timer: 2000,
              showConfirmButton: false,
              position: "top-end",
              toast: true,
            });

          const { items, id, is_finished, total } = responseCart.result;
          setData((prevState) => ({
            ...prevState,
            user: {
              ...prevState.user,
              cart: {
                id: id,
                items: items,
                is_finished: is_finished,
                total: total,
              },
            },
          }));
          Swal.fire({
            icon: "success",
            title: "موفقیت",
            text: responseCart.message,
            timer: 2000,
            showConfirmButton: false,
            position: "center-center",
            toast: true,
          });
        }
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "خطا",
        text: "خطا در کاهش محصول از سبد.",
        timer: 2000,
        showConfirmButton: false,
        position: "top-end",
        toast: true,
      });
    } finally {
      setDeleteItemLoading({
        deleteItemLoading: false,
      });
    }
  };
  const p = item.product;
  if (typeof p.inventory_of_product.final_price === "number")
    p.inventory_of_product.final_price = `${formatNumber(
      p.inventory_of_product.final_price
    )} تومان`;
  if (p)
    return (
      <div className="offcanvas1-basket-item">
        <div className="offcanvas1-basket-item-image">
          <Link
            to={"/Product/" + p.slug}
            className="offcanvas1-basket-item-image-link"
          >
            <img
              className="img-fluid offcanvas1-basket-item-image-element rounded"
              src={BASE_URL + p.product_cover}
              title={p.product_cover_title}
              alt={p.product_cover_alt}
              style={{ maxHeight: "60px" }}
            />
          </Link>
        </div>
        <div className="offcanvas1-basket-item-details">
          <h5 className="offcanvas1-basket-item-title">
            <Link
              to={"/Product/" + p.slug}
              className="offcanvas1-basket-item-link"
            >
              {p.product_name}
              {/* <span className="offcanvas1-basket-item-subtitle">
              item.subtitle
            </span> */}
            </Link>
          </h5>
          <h6 className="offcanvas1-basket-item-price">
            {p.inventory_of_product.final_price}
          </h6>
          <a
            onClick={handleRemoveItemCart}
            className="badge badge-danger offcanvas1-basket-item-remove border-0"
            style={{ borderRadius: 3 }}
          >
            <i className="fa fa-fw fa-times" />
            {deleteItemLoading.deleteItemLoading ? (
              <i className="fa fa-fw fa-refresh fa-spin" />
            ) : null}
            حذف
          </a>
        </div>
      </div>
    );
};
